import { render, staticRenderFns } from "./printDSLKSaleReturn.vue?vue&type=template&id=19b22575&scoped=true&"
import script from "./printDSLKSaleReturn.vue?vue&type=script&lang=js&"
export * from "./printDSLKSaleReturn.vue?vue&type=script&lang=js&"
import style0 from "./printDSLKSaleReturn.vue?vue&type=style&index=0&id=19b22575&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b22575",
  null
  
)

component.options.__file = "printDSLKSaleReturn.vue"
export default component.exports